import { PaymentSetupStepsProvider } from '@perpay-web/fintech/components/composite/PaymentSetup/usePaymentSetupStepsContext';
import { PaychexStepsProvider } from '@perpay-web/fintech/components/composite/PayrollPaymentSetup/usePaychexStepsContext';
import { PinwheelStepsProvider } from '@perpay-web/fintech/components/screens/Pinwheel/usePinwheelStepsContext';
import { UpdateDirectDepositStepsProvider } from '@perpay-web/fintech/components/screens/UpdateDirectDeposit/useUpdateDirectDepositStepsContext';
import { VirtualProvisioningModalStepsProvider } from '@perpay-web/fintech/hooks/useVirtualProvisioningModalStepsContext';
import { createCombinedProvider } from '@perpay-web/utils/componentUtils';

const StepsProviders = createCombinedProvider(
    PaymentSetupStepsProvider,
    VirtualProvisioningModalStepsProvider,
    PinwheelStepsProvider,
    UpdateDirectDepositStepsProvider,
    PaychexStepsProvider,
);

export default StepsProviders;
